export default {
  name: 'TrainingCampItem',

  props: {
    p_xlyClass: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    gotoTrainingCamp(xlyClass) {
      let path = 2 === xlyClass.xlyType ? '/training-camp-personal' : '/training-camp';
      path = `${path}/${xlyClass.xlyClassId}`;
      this.$router.push(path);
    },
  },
};
